import { AlertClassColour, ConfigSystemParams, msSize } from 'src/app/core/consts';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { BulkOrderModalFormComponent } from 'src/app/forms-modal/_provisioning/provision-bulk-order-modal-form/provision-bulk-order-modal-form.component';
import { catchError, Observable, throwError } from 'rxjs';
import { CommConfigService } from 'src/app/core/services/utelize/system/communication/comm-config-service';
import { CommunicationTemplateDTO } from 'src/app/core/models/system/communication/communication-template.dto';
import { CommunicationTemplateReplacements } from 'src/app/core/models/system/communication/communication-template-replacements';
import { CommunicationTemplatesDefaultsDTO } from 'src/app/core/models/system/communication/communication-templates-defaults.dto';
import { CompanyModalFormComponent } from '../../_company/company-modal-form/company-modal-form.component';
import { CompletedModalFormComponent } from 'src/app/forms-modal/_pop-ups/completed-modal-form/completed-modal-form.component';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DeliveryType, eUser, MessageType, TemplateModalAction } from 'src/app/core/enums';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { InviewUserDTO } from 'src/app/core/models/inview/inview-user.dto';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { ManageEsimModalFormComponent } from 'src/app/forms-modal/_manage-sim/manage-esim-modal-form/manage-esim-modal-form.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ProductsService } from 'src/app/core/services/utelize/system/product/products-service';
import { SimProvisionBulkEmbeddedComponent } from 'src/app/pages-embedded/sim-provision-bulk/sim-provision-bulk.component';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TemplateEmailModalFormComponent } from 'src/app/forms-modal/template-email-modal-form/template-email-modal-form.component';
import { TemplateSMSModalFormComponent } from 'src/app/forms-modal/template-sms-modal-form/template-sms-modal-form.component';
import { UserModalFormComponent } from '../../_user/user-modal-form/user-modal-form.component';
import { WarningModalFormComponent } from 'src/app/forms-modal/_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-provision-bulk-modal-form',
  templateUrl: './provision-bulk-modal-form.component.html',
  styleUrls: ['./provision-bulk-modal-form.component.scss']
})

export class ProvisionBulkModalFormComponent implements AfterViewInit, OnDestroy, OnInit {

  @Input() embeddedFormMode      : boolean | undefined;
  @Input() initialCompanyId      : number  | undefined;
  @Input() initialInviewCompanyId: number  | undefined;

  @Output() bulkiccidsHaveBeenProvisioned        : EventEmitter<void>  = new EventEmitter<void>();
  @Output() bulkProvisionESIMFormHasBeenCancelled: EventEmitter<void>  = new EventEmitter<void>();

  @ViewChild('bulkOrderEditForm',                 { static: false }) bulkOrderEditForm!                 : BulkOrderModalFormComponent;
  @ViewChild('companyModalForm',                  { static: false }) companyModalForm!                  : CompanyModalFormComponent;
  @ViewChild('completedModalForm',                { static: false }) completedModalForm!                : CompletedModalFormComponent;
  @ViewChild('emailTemplateModalForm',            { static: false }) emailTemplateModalForm!            : TemplateEmailModalFormComponent;
  @ViewChild('manageEsimModalForm',               { static: false }) manageEsimModalForm!               : ManageEsimModalFormComponent;
  @ViewChild('provisionBulkModalFormContent',     { static: false }) provisionBulkModalFormContent!     : TemplateRef<void>;
  @ViewChild('simProvisionBulkEmbeddedComponent', { static: false }) simProvisionBulkEmbeddedComponent! : SimProvisionBulkEmbeddedComponent;
  @ViewChild('smsTemplateModalForm',              { static: false }) smsTemplateModalForm!              : TemplateSMSModalFormComponent;
  @ViewChild('userModalForm',                     { static: false }) userModalForm!                     : UserModalFormComponent;
  @ViewChild('warningModalForm',                  { static: false }) warningModalForm!                  : WarningModalFormComponent;
  
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static"     : (value.toUpperCase()=="TRUE" ? true : false) }
  
  private bulkOrderEditFormIsOpen  : boolean=false;
  private companyDefaults!         : CommunicationTemplatesDefaultsDTO;
  private curUser                  : SystemUserDTO;
  private emailTemplate            : CommunicationTemplateDTO | undefined;
  private initialInviewCompanyIdSet: boolean=false;
  private smsTemplate              : CommunicationTemplateDTO | undefined;
  private templateEmailReplacements: CommunicationTemplateReplacements[] = [];
  private templateOpen             : boolean=false;
  private templateSMSReplacements  : CommunicationTemplateReplacements[] = [];
  private initialStatus            : string="Please complete the following details";
  private inviewCompanyIdData!     : IdAndDescriptionDTO[];
  private inviewUserIdData!        : InviewUserDTO[];
  private manageEsimFormIsOpen     : boolean=false;
  private productIdData!           : IdAndDescriptionDTO[];
  private provisionBulkModalFormRef! : NgbModalRef;
  private provisionButtonClicked   : boolean=false;
  private userModalFormIsOpen      : boolean=false;

  public addCompanyButtonEnabled   : boolean=true;
  public addUserButtonEnabled      : boolean=false;
  public alertColourOrderStatus    : string=AlertClassColour.Grey;
  public alertColourProgress       : string=AlertClassColour.Grey;
  public breadCrumbItems!          : Array<{}>;
  public formSubmitted             : boolean=false;
  public formTitle                 : string="SureSIM Bulk Provision";
  public inviewCompanyId           : number | undefined;
  public progressInformation       : string=this.initialStatus;
  public provisioningBulkForm!     : UntypedFormGroup;
  public provisionButtonEnabled    : boolean=false;
  public selectedRowData           : any;
  public sureSimCompanyId          : number | undefined;
  public warningMessageMain        : string | undefined;
  public warningMessageSub         : string | undefined;

  constructor(
    private authenticationService : AuthenticationService,
    private commConfigsService    : CommConfigService,
    private configSystemService   : ConfigSystemService,
    private exceptionsService     : ExceptionsService,
    private formBuilder           : UntypedFormBuilder,
    private lastPassKillerService : LastPassKillerService,
    private modalService          : NgbModal,
    private productsService       : ProductsService,
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {
      this.sureSimCompanyId=this.initialCompanyId;
      this.inviewCompanyId =this.initialInviewCompanyId

      if (this.embeddedFormMode) {
        this.startProcess();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy() {
    try {
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public resetMainVariables(): void {
    try {
      this.alertColourProgress      =AlertClassColour.Grey;
      this.formSubmitted            =false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public closeForm(): void {
    try {
      if (this.provisionButtonClicked) {
        this.bulkiccidsHaveBeenProvisioned.emit();
      }
      this.bulkProvisionESIMFormHasBeenCancelled.emit();

      if (!this.embeddedFormMode)
        this.provisionBulkModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openForm(companyId:number, inviewCompanyId:number): void {
    try {
      this.sureSimCompanyId = companyId;
      this.inviewCompanyId  = inviewCompanyId;
      this.startProcess();
      this.openModal();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private openModal(): void {
    try {
        this.provisionBulkModalFormRef = this.modalService.open(this.provisionBulkModalFormContent, { backdrop: this.modalBackGround,
                                                                centered : true,
                                                                keyboard : false,
                                                                size     : msSize.FullScreen, //'mysize'
                                                                }); //windowClass: 'mysize'
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private startProcess(): void {
    try {
      this.refreshInviewCompanyData();
      this.setUpForm();
      this.refreshTemplateData();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //RBW_20260604 - Fetch both templates and replacements whenever the company changes
  private refreshTemplateData(): void {
    try {
      if (this.sureSimCompanyId != undefined && this.sureSimCompanyId > 0) {
        this.getTemplateData(MessageType.ProvisioningViaEmail, DeliveryType.Email);
        this.getTemplateData(MessageType.ProvisioningViaSMS,   DeliveryType.SMS);
        this.getTemplateReplacements();
        this.getTemplateDefaults();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region provisioningBulkForm

  get formData() {
    return this.provisioningBulkForm.controls;
  }

  private setUpForm() {
    try {
      this.buildForm();
      this.enableDisableControls(false);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.removeFormFields(this.provisioningBulkForm);
      this.provisioningBulkForm=this.formBuilder.group({ });
      this.addFormFields(this.provisioningBulkForm);
      this.provisioningBulkForm.addControl("simProvisionBulkEmbeddedComponent", new FormControl(null, []));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.provisioningBulkForm) {

      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : string,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public saveFormData() {
    try {
      this.formSubmitted=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private enableDisableControls(enabled: boolean) {
    try {
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private disableAllControls() {
    try {
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  //#endregion

  //#region BulkOrders

  //#endregion

  //#region Dropdown Arrays

  public getDropdownDataObjectArray(fieldName: string) {
    try {
      if (fieldName=="inviewCompanyId") {
        return this.inviewCompanyIdData;

      } else if (fieldName=="productId") {
        return this.productIdData;
      }

      return undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  public getDropdownDataObjectArray_InviewUser() {
    try {
      return this.inviewUserIdData;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  private getDropdownData(dataSource: Observable<any>, fieldName: string) {
    try {
      if (dataSource) {
        dataSource
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (fieldName=="inviewCompanyId") {
              this.inviewCompanyIdData=(data as IdAndDescriptionDTO[]);

              if (!this.initialInviewCompanyIdSet && this.initialInviewCompanyId != undefined && this.initialInviewCompanyId>0) {
                this.provisioningBulkForm.controls["inviewCompanyId"].setValue(this.initialInviewCompanyId);
                
                this.initialInviewCompanyIdSet=true;
              }

              this.inviewCompanySelectDropDownChange(undefined);

            } else if (fieldName=="productId") {
              this.productIdData=(data as IdAndDescriptionDTO[]);

            } 
           },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Inview Company
  
  public refreshInviewCompanyData() {
    try {
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public inviewCompanySelectDropDownChange(ev: any) {
    try {
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region SureSIM Product

  public refreshProductData() {
    try {
      this.getDropdownData(this.productsService.getAvailableIdAndDescription(), "productId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Templates

  //RBW_20260604 - Mirrors ProvisionModalFormComponent.getTemplateData — loads the company-scoped SMS or Email template
  private getTemplateData(messageType: number, deliveryType: number): void {
    try {
      if (this.sureSimCompanyId != undefined && this.sureSimCompanyId > 0) {
        this.commConfigsService.getCommunicationTemplate(this.sureSimCompanyId as number, messageType, deliveryType)
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
            })
          )
          .subscribe({
            next : data => {
              if (data.messageTypeId == MessageType.ProvisioningViaEmail) this.emailTemplate = data;
              if (data.messageTypeId == MessageType.ProvisioningViaSMS)   this.smsTemplate   = data;
            },
            error: error => { this.exceptionsService.handleException(new Error(error)); }
          });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private getTemplateDefaults(): void {
    try {
      this.commConfigsService.getCompanyCommunicationTemplatesDefaults(this.sureSimCompanyId as number)
        .subscribe({
          next : data => { this.companyDefaults = JSON.parse(JSON.stringify(data ?? {})); },
          error: error => {
            if (error && error.includes("404")) {
              this.companyDefaults = { bcc: undefined, cc: undefined, companyId: this.sureSimCompanyId, enteredBy: this.curUser.userId, fromEmail: undefined, fromNumber: undefined, id: undefined, toEmail: undefined, toNumber: undefined };
            } else {
              this.exceptionsService.handleException(new Error(error));
            }
          }
        });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private getTemplateReplacements(): void {
    try {
      this.commConfigsService.getCommunicationTemplateReplacements(this.curUser.userId, MessageType.ProvisioningViaEmail).subscribe(x => this.templateEmailReplacements = x);
      this.commConfigsService.getCommunicationTemplateReplacements(this.curUser.userId, MessageType.ProvisioningViaSMS).subscribe(x => this.templateSMSReplacements   = x);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public emailTemplateModalFormClosed(event: {TemplateModalAction: TemplateModalAction, TemplateId: number}): void {
    try {
      this.templateOpen = false;
      this.getTemplateData(MessageType.ProvisioningViaEmail, DeliveryType.Email);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openEmailTemplate(): void {
    try {
      this.templateOpen = true;
      this.emailTemplateModalForm.openForm("", JSON.parse(JSON.stringify(this.emailTemplate!)), this.sureSimCompanyId!, this.templateEmailReplacements, this.companyDefaults, true, false, true, true, true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openSmsTemplate(): void {
    try {
      this.templateOpen = true;
      this.smsTemplateModalForm.openForm("", JSON.parse(JSON.stringify(this.smsTemplate!)), this.sureSimCompanyId!, this.templateSMSReplacements, this.companyDefaults, true, false, true, true, true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onCompanyIdChanged(companyId: number): void {
    try {
      this.sureSimCompanyId = companyId;
      this.refreshTemplateData();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public smsTemplateModalFormClosed(event: {TemplateModalAction: TemplateModalAction, TemplateId: number}): void {
    try {
      this.templateOpen = false;
      this.getTemplateData(MessageType.ProvisioningViaSMS, DeliveryType.SMS);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Process Complete

  public completedModalHasBeenClosed() {
    try {
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public bulkOrderDataHasBeenSaved() {
    try {
      this.bulkOrderEditFormIsOpen=false;

      this.simProvisionBulkEmbeddedComponent.refresh()
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public bulkOrderFormHasBeenCancelled() {
    try {
       this.bulkOrderEditFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public editOrder(data: { orderGuid: string; orderId: number, validationMessages: string[], userExists: boolean }) {
    try {
      if (!this.bulkOrderEditFormIsOpen) {
        this.bulkOrderEditFormIsOpen=true;

        const mobileConflictMessage = (data.validationMessages ?? []).find(m => m.startsWith("Mobile")) ?? "";

        this.bulkOrderEditForm.openForm(data.orderGuid, data.orderId, mobileConflictMessage, data.userExists);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

    public bulkProvisionButtonClick() {
    try {
      this.provisionButtonClicked=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

    public orderLinkClick(orderId:number) {
    try {

      if (!this.manageEsimFormIsOpen) {
      
        if (orderId==undefined || <number>orderId<=0) {
          throw new Error("ProvisionBulkModalFormComponent..SureSIM OrderID cannot be determined");
        }
        
        this.manageEsimFormIsOpen=true;
        this.manageEsimModalForm.openForm(orderId);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

    public userLinkClick(userId:number) {
    try {

      if (!this.userModalFormIsOpen) {
      
        if (userId==undefined || <number>userId<=0) {
          throw new Error("ProvisionBulkModalFormComponent..SureSIM UserId cannot be determined");
        }
        
        this.userModalFormIsOpen=true;
        this.userModalForm.openForm(userId, eUser.sim);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
